import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getBrands, deleteBrand } from "./modules/actions";

const mapStateToProps = (state) => ({
  state: {
    brands: state.brandReducer.brands,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getBrands,
      deleteBrand
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
